import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getBudgetPeriodDates, setDateHelper } from '../../utils/Helper';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import Button from '../../components/ui/Button';
import CustomReactSelect from '../../components/ui/CustomReactSelect';

const months = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
];

const SelectMonthAndYearModal = ({ apiTrigger, billingDate, onContinue, selectMonth }: any) => {

    const checkContribution = useMakeRequest();
    const currentYear = moment().year();
    const currentMonth = moment().month();

    const years = Array.from({ length: 21 }, (_, i) => ({
        label: currentYear + i,
        value: currentYear + i,
    }));
    let currentMonthObj = months.find(month => month.value === currentMonth)
    const [selectedYear, setSelectedYear]: any = useState(years[0]);
    const [selectedMonth, setSelectedMonth]: any = useState(currentMonthObj);
    const [errorMessage, setErrorMessage] = useState<string | null>(null)


    const handleContinue = () => {
        if (!selectedYear) {
            setErrorMessage('Please select year.')
        } else if (selectedMonth === null) {
            setErrorMessage('Please select month.')
        } else {
            setErrorMessage(null)
            console.log("selectedYear: ", selectedYear);
            console.log("selectedMonth: ", selectedMonth);
            const { startDate, endDate } = getBudgetPeriodDates(
                selectedYear.value,
                selectedMonth?.value,
                billingDate
            );
            console.log("startDate --", startDate)
            console.log("endDate --", endDate)
            checkContribution.makeRequest({
                url: ApiConstants?.ContributionsCheck,
                payload: {
                    month: months[selectedMonth?.value]?.value,
                    year: moment(startDate).get('year'),
                    other_params: {
                        start_date: startDate,
                        end_date: endDate,
                        month: months[selectedMonth?.value]?.value + 1,
                        selected_month: months[selectedMonth?.value]?.label
                    }
                }
            })
        }
    };

    useEffect(() => {
        if (checkContribution?.status) {

            selectMonth(checkContribution?.data?.data?.other_params?.selected_month)
            onContinue({
                start_date: checkContribution?.data?.data?.other_params?.start_date,
                end_date: checkContribution?.data?.data?.other_params?.end_date,
                month: checkContribution?.data?.data?.other_params?.month,
                check: {
                    finalized_type: checkContribution?.data?.data?.finalized_type,
                    is_finalized: checkContribution?.data?.data?.is_finalized,
                    can_finalize: checkContribution?.data?.data?.can_finalize
                }
            })
            const modal: any = $('#selectDateModal');
            modal.modal('hide')
            $('.modal-backdrop').remove();
        }
        // handleContinue()
    }, [checkContribution?.status])


    return (
        <div className="modal fade bottom-sheet-modal bottom-sheet-select-modal" id="selectDateModal" tabIndex={-1} aria-labelledby="selectDateModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="selectDateModal">Select Budget Period</h1>
                    </div>
                    <div className="page-padding-x" style={{ paddingBottom: '32px' }}>

                        <CustomReactSelect
                            label="Select Year"
                            value={selectedYear}
                            options={years}
                            className="com-r-select"
                            classNamePrefix="com-r-select"
                            placeholder="Select Year"
                            onChange={(option) => setSelectedYear(option)}
                            closeMenuOnScroll={true}
                            closeMenuOnSelect={true}
                        />

                        <div style={{ marginBottom: '24px' }} />

                        <CustomReactSelect
                            label="Select Month"
                            value={selectedMonth}
                            options={months}
                            className="com-r-select"
                            classNamePrefix="com-r-select"
                            placeholder="Select Month"
                            onChange={(option) => {
                                setSelectedMonth(option)
                            }}
                            closeMenuOnScroll={true}
                            closeMenuOnSelect={true}
                        />

                        {errorMessage ? <p className='text-error' style={{ marginTop: '16px', marginBottom: '16px' }}>{errorMessage}</p> : ''}

                        <Button className='com-btn mt-5' style={{ width: "100%" }} onClick={handleContinue} loading={checkContribution?.loading}>Continue</Button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectMonthAndYearModal;